import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { useConfig } from "@/hooks/useHoodbank";
import Landing from "@/pages/Landing";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";

function Shell() {
  const config = useConfig();
  return (
    <div className="min-h-screen flex flex-col">
      <div className="noise-overlay" />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <Footer config={config} />
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0C0C0C", border: "1px solid rgba(255,255,255,0.1)", color: "#F8FAFC" } }} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
